import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// const echarts = require('echarts');
import * as echarts from 'echarts';
let default_1 = class default_1 extends Vue {
    dataSeries;
    dataX;
    timeIntervalType;
    color;
    lineChart;
    option = {
        color: [this.color],
        grid: {
            top: 20,
            left: 0,
            width: '100%',
            height: 30,
            tooltip: {
                show: false,
            },
        },
        xAxis: {
            type: 'category',
            show: false,
            data: [],
        },
        yAxis: {
            show: false,
            type: 'value',
        },
        series: [
            {
                data: [],
                type: 'line',
                areaStyle: {},
                animation: false,
                showSymbol: false,
                smooth: true,
            },
        ],
    };
    mounted() {
        this.draw();
    }
    draw() {
        this.$nextTick(() => {
            this.lineChart = echarts.init(this.$refs['line-chart']);
            this.lineChart.clear();
            this.lineChart.resize();
            this.lineChart.setOption(this.option, true);
        });
    }
    onDataXChange(newVal) {
        if (!newVal) {
            return;
        }
        this.option.xAxis.data = newVal.map((item, index) => index);
        this.option.series[0].data = newVal;
        this.lineChart && this.lineChart.setOption(this.option);
    }
};
__decorate([
    Prop()
], default_1.prototype, "dataSeries", void 0);
__decorate([
    Prop()
], default_1.prototype, "dataX", void 0);
__decorate([
    Prop()
], default_1.prototype, "timeIntervalType", void 0);
__decorate([
    Prop()
], default_1.prototype, "color", void 0);
__decorate([
    Watch('dataX', { immediate: true, deep: true })
], default_1.prototype, "onDataXChange", null);
default_1 = __decorate([
    Component({
        name: 'Dashboard',
    })
], default_1);
export default default_1;
